module.exports = __webpack_public_path__ + "static/img/title-icon.77cb7cf0.png";